import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@mpt-fo/common/shared/shared.module';
import { AmountInputComponent } from './amount-input/amount-input.component';
import { SearchInputComponent } from './search-input/search-input.component';
import { LoadableContentComponent } from './loadable-content/loadable-content.component';
import { InfoBoxComponent } from './info-box/info-box.component';
import { BusinessTypeSelectionBoxComponent } from './business-type-selection-box/business-type-selection-box.component';


@NgModule({
    declarations: [
        AmountInputComponent,
        SearchInputComponent,
        InfoBoxComponent,
        LoadableContentComponent,
        BusinessTypeSelectionBoxComponent,
    ],
    imports: [
        CommonModule,
		SharedModule,
    ],
    exports: [
        AmountInputComponent,
        SearchInputComponent,
        InfoBoxComponent,
        LoadableContentComponent,
        BusinessTypeSelectionBoxComponent,
    ]
})
export class PrequalificationSharedModule {}
